import { useRef } from "react";
import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

export const ProductSpotlight = ({ src, alt }) => {
  const imgRef = useRef(null);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    e.currentTarget.style.setProperty("--mx", `${x}%`);
    e.currentTarget.style.setProperty("--my", `${y}%`);
    if (imgRef.current) imgRef.current.style.transformOrigin = `${x}% ${y}%`;
  };

  return (
    <motion.div
      initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
      animate={{ clipPath: "inset(0% 0% 0% 0%)" }}
      transition={{ duration: 1.3, ease: EASE }}
      onMouseMove={onMove}
      className="spotlight group relative aspect-[4/5] w-full cursor-zoom-in overflow-hidden rounded-[2rem] bg-parchment ring-1 ring-copper/25"
      data-testid="product-spotlight"
    >
      <img ref={imgRef} src={src} alt={alt} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.6]" />
    </motion.div>
  );
};
